import { mascaraCNPJ, mascaraCPF } from './cnpj';

export function formatarParaMoedaBRL(valor: number): string {
    return !valor ? '' : valor.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }
   
  export function formatarCNPJ(cnpj: string): string {
    return mascaraCNPJ(cnpj);
  }
   
  export function formatarCPF(cpf: string): string {
    return mascaraCPF(cpf);
  }